import { loadedAssets } from "@/loader";
import { tileToWorld } from "@/utils/tile";
import { AsepriteResource } from "@excaliburjs/plugin-aseprite";
import { Actor, Color, Vector, vec } from "excalibur";

export class NPCManager {
  scene: any;
  npcs: Map<any, { npc: Actor; pathToDestination: Vector[] }>;
  tilemapPosition: Vector;

  constructor(scene, cameraPosition: Vector) {
    this.scene = scene;
    this.npcs = new Map();
    this.tilemapPosition = cameraPosition;
  }

  addNPC({
    id,
    type,
    position,
  }: {
    id: string;
    type: string;
    position: Vector;
  }) {
    if (this.npcs.has(id)) return;

    const resource = loadedAssets[type] as AsepriteResource;

    if (!resource) return;

    const npc = new Actor({
      pos: this.tilemapPosition.add(tileToWorld(position)),
      z: 99,
    });

    npc.graphics.use(resource.getAnimation("down") as any);
    this.npcs.set(id, { npc, pathToDestination: [] });
    this.scene.add(npc);
  }

  removeNPC(id: string) {
    const npcData = this.npcs.get(id);
    if (npcData) {
      this.scene.remove(npcData.npc);
      this.npcs.delete(id);
    }
  }

  moveNPC(id: string, newPosition: Vector) {
    const npcData = this.npcs.get(id);
    if (npcData) {
      npcData.npc.pos = newPosition;
    }
  }

  getNPC(id: string): Actor | undefined {
    return this.npcs.get(id)?.npc;
  }

  getAllNPCs(): Actor[] {
    return Array.from(this.npcs.values()).map((data) => data.npc);
  }

  setNPCPath(id: string, path: Vector[]) {
    const npcData = this.npcs.get(id);
    if (npcData) {
      console.log("hoi");
      npcData.pathToDestination = path;
    }
  }

  updateNPCMovements(delta: number) {
    this.npcs.forEach((data) => {
      if (data.pathToDestination.length > 0) {
        this.moveAlongPath(data, delta);
      }
    });
  }

  private moveAlongPath(
    npcData: { npc: Actor; pathToDestination: Vector[] },
    delta: number
  ) {
    const currentTarget = npcData.pathToDestination[0];

    if (!currentTarget) return;

    const targetPos = this.tilemapPosition.add(tileToWorld(currentTarget));
    const distanceToTarget = npcData.npc.pos.distance(targetPos);

    if (distanceToTarget <= 5) {
      npcData.pathToDestination.shift();
      return;
    }

    const direction = targetPos.sub(npcData.npc.pos).normalize();
    npcData.npc.pos = npcData.npc.pos.add(
      direction.scale((200 * delta) / 1000)
    );

    this.setNPCAnimation(npcData.npc, direction);
  }

  private setNPCAnimation(npc: Actor, direction: Vector) {
    const resource = loadedAssets["dog"] as AsepriteResource;

    if (Math.abs(direction.x) > Math.abs(direction.y)) {
      if (direction.x > 0) {
        npc.graphics.use(resource.getAnimation("side") as any);
        npc.graphics.flipHorizontal = true; // Flip when moving right
      } else {
        npc.graphics.use(resource.getAnimation("side") as any);
        npc.graphics.flipHorizontal = false; // Default for left
      }
    } else {
      npc.graphics.flipHorizontal = false; // Reset flip for vertical movement
      npc.graphics.use(
        direction.y > 0
          ? (resource.getAnimation("down") as any)
          : (resource.getAnimation("up") as any)
      );
    }
  }
}
